// extracted by mini-css-extract-plugin
module.exports = {"sgihk0f":"sgihk0f"};